<template>
  <div class="brand-list-wrap fl">
    <Carousel
      class="brand-banner-list"
      :interval="3000"
      :arrow="brandList.length > 1 ? 'always' : 'never'"
      :height="showHeight"
      trigger="click"
      indicator-position="none"
      :autoplay="false"
    >
      <carousel-item
        v-for="(item, index) in brandList"
        :key="index"
      >
      <!-- 已经修改新窗口 -->
        <ul class="clear brand-list">
          <li
            v-for="i in item"
            :key="i.brandId"
            @click="brandClickHandle(i)"
            class="fl list-item"
          >
            <router-link
              :target="isFeishuOrDingding ? '_self' : '_blank'"
              class="brand-img tc"
              :to="{ name: 'newBrandDetail', params: { brandId: i.brandId } }"
            >
              <img
                :src="i.logo"
                alt=""
              />
            </router-link>
          </li>
        </ul>
      </carousel-item>
    </Carousel>
  </div>
</template>

<script>
import { CarouselItem, Carousel } from 'element-ui';
import { gioClickHandle } from '@utils';
export default {
  name: 'BrandList',

  components: {
    Carousel,
    CarouselItem,
  },

  methods: {
    brandClickHandle(i = {}) {
      const gioParams = {
        df_channle: "生日汇",
        df_pagename: "频道首页",
        df_modulename: "品牌墙",
        df_elementname: i.merchantType == 2 ? "品牌电子券" : "蛋糕", // 1: 蛋糕品牌；2: 品牌电子券
        df_brand: i.name || ""
      }
      // 点击品牌墙品牌
      gioClickHandle('DF_elementClick', gioParams);
    }
  },

  props: {
    brandList: {
      type: Array,
      default: () => [],
    },
    showHeight: {
      type: String,
      default: '266px',
    }
  },
};
</script>

<style lang="less" scoped>
.brand-list-wrap {
  width: 912px;
  border-top: 1px solid #ececec;
  .list-item {
    width: 20%;
    border: 1px solid #ececec;
    border-top: none;
    border-left: none;
    box-sizing: border-box;
    &:hover {
      .brand-img {
        opacity: 0.9;
      }
    }
  }
  .brand-img {
    display: block;
    font-size: 0;
    padding: 6px 0;
    img {
      width: 120px;
      height: 120px;
    }
  }
  /deep/ .brand-banner-list {
    &:hover {
      .el-carousel__arrow {
        background: rgba(0, 0, 0, 0.6);
      }
    }
    .el-carousel__arrow {
      width: 30px;
      height: 40px;
      background: #000;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 0;
      &.el-carousel__arrow--left {
        left: 5px;
      }
      &.el-carousel__arrow--right {
        right: 5px;
      }
      i {
        width: 100%;
        height: 100%;
        &::before {
          content: none;
        }
        &.el-icon-arrow-left {
          background: url("../../assets/images/birthday/brand_pre.png") 0 0
            no-repeat;
          background-size: 100% 100%;
        }
        &.el-icon-arrow-right {
          background: url("../../assets/images/birthday/brand_next.png") 0 0
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
